import { render } from "./Budgets.vue?vue&type=template&id=5f9ec18d"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Budgets.vue?vue&type=style&index=1&id=5f9ec18d&lang=css"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__